import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { MouseEvent } from 'react';

const propTypes = {
  visible: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  visible: false,
  onClick(_event: MouseEvent<SVGElement>) {},
};

type EyesIconProps = PropsType<typeof propTypes, typeof defaultProps>;

function EyesIcon({ visible, onClick }: EyesIconProps) {
  if (visible) {
    return (
      <svg
        fill="none"
        height="15"
        viewBox="0 0 16 11"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          d="M8 2.6875C7.75391 2.71484 7.37109 2.76953 7.125 2.82422C7.23438 3.01562 7.31641 3.37109 7.34375 3.5625C7.34375 4.41016 6.63281 5.09375 5.8125 5.09375C5.59375 5.09375 5.23828 5.01172 5.07422 4.90234C4.99219 5.14844 4.9375 5.50391 4.9375 5.75C4.9375 7.44531 6.30469 8.8125 8 8.8125C9.69531 8.8125 11.0625 7.44531 11.0625 5.75C11.0625 4.08203 9.69531 2.6875 8 2.6875ZM15.7656 5.36719C14.2891 2.46875 11.3359 0.5 8 0.5C4.63672 0.5 1.68359 2.46875 0.207031 5.36719C0.152344 5.47656 0.125 5.64062 0.125 5.77734C0.125 5.88672 0.152344 6.05078 0.207031 6.16016C1.68359 9.05859 4.63672 11 8 11C11.3359 11 14.2891 9.05859 15.7656 6.16016C15.8203 6.05078 15.8477 5.88672 15.8477 5.75C15.8477 5.64062 15.8203 5.47656 15.7656 5.36719ZM8 9.6875C5.29297 9.6875 2.80469 8.18359 1.49219 5.75C2.80469 3.31641 5.29297 1.8125 8 1.8125C10.6797 1.8125 13.168 3.31641 14.4805 5.75C13.168 8.18359 10.6797 9.6875 8 9.6875Z"
          fill="#5C5C5C"
        />
      </svg>
    );
  }

  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 18 15"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M17.6133 13.6289C17.7227 13.7201 17.7773 13.8294 17.7773 13.957C17.7773 14.0664 17.7409 14.1667 17.668 14.2578L17.3945 14.5859C17.3216 14.6953 17.2122 14.75 17.0664 14.75C16.957 14.75 16.8659 14.7135 16.793 14.6406L0.441406 1.87109C0.332031 1.77995 0.277344 1.67057 0.277344 1.54297C0.277344 1.43359 0.313802 1.33333 0.386719 1.24219L0.660156 0.914062C0.733073 0.804688 0.842448 0.75 0.988281 0.75C1.09766 0.75 1.1888 0.786458 1.26172 0.859375L17.6133 13.6289ZM8.39844 4.74219C8.59896 4.70573 8.80859 4.6875 9.02734 4.6875C9.84766 4.6875 10.5495 4.97917 11.1328 5.5625C11.7344 6.1276 12.0534 6.82031 12.0898 7.64062L8.39844 4.74219ZM9.65625 10.7578C9.45573 10.7943 9.24609 10.8125 9.02734 10.8125C8.20703 10.8125 7.49609 10.5299 6.89453 9.96484C6.3112 9.38151 6.0013 8.67969 5.96484 7.85938L9.65625 10.7578ZM9.02734 3.8125C8.53516 3.8125 8.00651 3.8763 7.44141 4.00391L6.15625 3.01953C7.1224 2.67318 8.07943 2.5 9.02734 2.5C10.1211 2.5 11.1693 2.70964 12.1719 3.12891C13.1927 3.52995 14.0951 4.09505 14.8789 4.82422C15.6628 5.53516 16.3099 6.3737 16.8203 7.33984C16.875 7.46745 16.9023 7.60417 16.9023 7.75C16.9023 7.89583 16.875 8.03255 16.8203 8.16016C16.4193 8.90755 15.9362 9.59115 15.3711 10.2109L14.332 9.39062C14.806 8.89844 15.207 8.35156 15.5352 7.75C14.8607 6.52865 13.9401 5.57161 12.7734 4.87891C11.625 4.16797 10.3763 3.8125 9.02734 3.8125ZM9.02734 11.6875C9.51953 11.6875 10.0482 11.6237 10.6133 11.4961L11.8984 12.4805C10.9323 12.8268 9.97526 13 9.02734 13C7.36849 13 5.84635 12.5625 4.46094 11.6875C3.07552 10.7943 2 9.61849 1.23438 8.16016C1.17969 8.03255 1.15234 7.89583 1.15234 7.75C1.15234 7.60417 1.17969 7.46745 1.23438 7.33984C1.63542 6.59245 2.11849 5.90885 2.68359 5.28906L3.72266 6.10938C3.2487 6.60156 2.84766 7.14844 2.51953 7.75C3.19401 8.97135 4.10547 9.9375 5.25391 10.6484C6.42057 11.3411 7.67839 11.6875 9.02734 11.6875Z"
        fill="#5C5C5C"
      />
    </svg>
  );
}

EyesIcon.propTypes = propTypes;
EyesIcon.defaultProps = defaultProps;

export default EyesIcon;
